module.exports = __webpack_public_path__ + "img/pr-8.d0a4f9ff.png";